import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { Card } from '../../ui/Card'
import { useScrollAnimation } from '../../../hooks/useScrollAnimation'

interface CommercialItem {
  id: string
  title: string
  description: string
}

export function HowWeWorkCommercial() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const items = t('howWeWorkPage.commercial.items', { returnObjects: true }) as CommercialItem[]

  return (
    <section ref={ref} className="py-24">
      <Container size="wide">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t('howWeWorkPage.commercial.label')}
          </span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
            {t('howWeWorkPage.commercial.title')}
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <Card variant="default" className="h-full text-center">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-accent/10 text-xl font-semibold text-accent-light">
                  {index + 1}
                </div>
                <h3 className="mt-5 text-lg font-medium text-text-primary">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-text-secondary">{item.description}</p>
              </Card>
            </motion.div>
          ))}
        </div>
      </Container>
    </section>
  )
}
